import { EASE, getTweenAsync } from "../../framework/src/modules/Tween";
import * as PIXI from "pixi.js-legacy";

export default class JumpSprite {
    constructor(){

    }

    static async jump(
        spriteToAnimate: PIXI.Sprite, // animationContainer,
        effectToAnimate: PIXI.AnimatedSprite
    ) {
        effectToAnimate.visible = true;        
        spriteToAnimate.visible = true;
        spriteToAnimate.alpha = 1;

        await getTweenAsync(
            spriteToAnimate,
            { y: -45, rotation: 0.05 }, // -100 // -36
            50,//100,
            EASE.CIRC_O
        ).then(async () => {
            await getTweenAsync(
                spriteToAnimate,
                { y: 0, rotation: -0.1 },
                300,
                EASE.CIRC_I
            );
            effectToAnimate.alpha = 1;
            effectToAnimate.play();

            await getTweenAsync(
                spriteToAnimate,
                { rotation: 0 },
                300,
                EASE.ELAS_O //BOUN_IO
            );
        });
    }
}